/**
 * Reporting somebody.
 *
 * A reason from a short list and a line of anything else. What they last said
 * goes with it from the server's side, so nobody has to copy it out, and so a
 * report cannot put words in anybody's mouth.
 */

import { useState } from 'react';
import { CloseButton } from './CloseButton';
import { useDraggableWindow } from './draggable';

const REASONS = [
  'Offensive language',
  'Harassment',
  'Cheating or botting',
  'Scamming',
  'Something else',
];

export function ReportForm({
  name,
  onSend,
  onClose,
}: {
  name: string;
  onSend: (reason: string, note: string) => void;
  onClose: () => void;
}): JSX.Element {
  const { attach, style, onPointerDown } = useDraggableWindow('report');
  const [reason, setReason] = useState(REASONS[0] ?? '');
  const [note, setNote] = useState('');

  return (
    <div className="trade report-form" ref={attach} style={style}>
      <div className="panel-head drag-handle" onPointerDown={onPointerDown}>
        <span>Report {name}</span>
        <CloseButton onClose={onClose} />
      </div>
      <div className="panel-body">
        <p className="hint">
          What they said most recently is sent with this. Somebody who keeps the peace will look at
          it.
        </p>
        <div className="setting">
          <span>Why</span>
          <select value={reason} onChange={(event) => setReason(event.target.value)}>
            {REASONS.map((one) => (
              <option key={one} value={one}>
                {one}
              </option>
            ))}
          </select>
        </div>
        <textarea
          className="report-note"
          maxLength={300}
          placeholder="Anything else worth knowing (optional)"
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />
        <div className="trade-buttons">
          <button
            type="button"
            className="primary"
            onClick={() => {
              onSend(reason, note);
              onClose();
            }}
          >
            Send report
          </button>
          <button type="button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
